import './scripts/common';
import './scripts/common-nav';
import {translate} from '@elements/translations';

let _config = window['_config'] || {};

// @ts-ignore
window.app = window['app'] || {
    debug: false,
};

// Todo: Add page specific JS here e.g:
import * as lightbox from './scripts/lightbox';
lightbox.init();

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element);
});

import * as selectLoadUrl from './scripts/select-load-url';
selectLoadUrl.init();

import * as scrollingTable from './scripts/scrolling-table';
scrollingTable.init();


import * as scrollSlider from '@elements/scroll-slider';
import {onFind} from "@elements/init-modules-in-scope";

function customArrowRenderFunction(container, direction, disabled, options) {
    let markupElement = document.createElement('div'),
        arrowMarkup = `<button type="button" class="${options.arrowClass} ${direction === 0 ? options.arrowPrevClass : options.arrowNextClass}" aria-label="${direction === 0 ? options.arrowAriaLabelPrev : options.arrowAriaLabelNext}" ${disabled ? 'disabled' : ''}><span class="scroll-slider__arrow-icon ${options.arrowIconClass}" aria-hidden="true" title="Search"></span></button>`;
    markupElement.innerHTML = arrowMarkup;
    let newArrow = markupElement.childNodes[0];
    container.appendChild(newArrow);

    return newArrow;
}

function dotsDefaultRenderFunction(id = null, dotContainer, options) {
    let markupElement = document.createElement('div'),
        dotMarkup = `<span class="img-slider-area__dot js-scroll-slider__dots-btn ${id === 0 ? 'is-active' : '' }"></span>`;
    markupElement.innerHTML = dotMarkup;
    let newDot = markupElement.childNodes[0];
    dotContainer.appendChild(newDot);

    return newDot;
}

scrollSlider.init({
    arrowIconClass:"icon icon-chevron",
    arrowAriaLabelPrev: translate('scroll-slider.arrow.previous'),
    arrowAriaLabelNext: translate('scroll-slider.arrow.next'),
    arrowRenderFunction: customArrowRenderFunction,
    dots: true,
    dotsRenderFunction: dotsDefaultRenderFunction
}, {
    base: '.js-scroll-slider',
    area: '.js-scroll-slider__area',
    item: '.js-scroll-slider__item',
    dotsContainer: '.js-scroll-slider__dots-container',
    slides: 3,
});
